import { ResetPasswordPage } from '@discovr/ui';
import { getRouteApi, useNavigate } from '@tanstack/react-router';

const resetPasswordRoute = getRouteApi('/reset-password');

export default function BrandResetPasswordPage() {
  const navigate = useNavigate();
  const { oobCode } = resetPasswordRoute.useSearch();
  return (
    <ResetPasswordPage
      oobCode={oobCode}
      appName="Discovr"
      onSuccess={() => navigate({ to: '/start' })}
    />
  );
}
